import request from '@/utils/request'


/**
 * 添加薪资模板
 * @param data
 */
export function addCommissonTemplate(data) {
  return request({
    url: '/admin/salary/cmi/addCommissonTemplate',
    method: 'post',
    data: data
  })
}

/**
 * 修改薪资模板
 * @param data
 */
export function updateCommissonTemplate(data) {
  return request({
    url: '/admin/salary/cmi/updateCommissonTemplate',
    method: 'post',
    data: data
  })
}

/**
 * 查询门店薪资模板
 * @param data
 */
export function selectAllCmi(params) {
  return request({
    url: '/admin/salary/cmi/selectAll',
    method: 'get',
    params: params
  })
}

/**
 * 获取课时费计算方式
 * @param data
 */
export function getSalaryClassType(params) {
  return request({
    url: '/admin/store/setting/getSalaryClassType',
    method: 'get',
    params: params
  })
}

/**
 * 保存课时费计算方式
 * @param data
 */
export function saveSalaryClassType(params) {
  return request({
    url: '/admin/store/setting/saveSalaryClassType',
    method: 'get',
    params: params
  })
}











// WEBPACK FOOTER //
// ./src/api/salary/SalaryCommisson.js